import React from 'react';

import { Box } from '@chakra-ui/react';
import Collapse from '@material-ui/core/Collapse';
import AlertBox from 'components/Alert/Alert';
import { updateAnswerAction } from 'screens/Engagement/pulseSurveyActions';

import { ENGAGEMENT_ANSWER_TYPES } from 'constants/ProjectConstants';
import { isMobileView } from 'constants/isMobileView';

import { AutoResizeInput } from 'uiToolkitV1/AutoResizeInput';
import { TextBodyMedium, TextHeader1 } from 'uiToolkitV1/Typography';

import { InteractiveInput } from './InteractiveInput';

const EngagementQuestionCard = ({ surveyId, serialNumber, question, dispatch, isPreview }) => {
  const {
    id,
    isRequired,
    description,
    answerType,
    enableFeedbackText,
    answerOptions,
    feedbackText,
    selectedAnswerOptions,
    isTextRequired,
    isVisited,
  } = question;

  let alertMessage = '';
  if (isVisited) {
    if (answerType === ENGAGEMENT_ANSWER_TYPES.NONE) {
      if ((isRequired || isTextRequired) && !feedbackText) alertMessage = 'Please add the required comment.';
    } else if (isRequired && selectedAnswerOptions.length === 0) {
      alertMessage = 'Please select one option.';
    } else if (isTextRequired && !feedbackText && (isRequired || selectedAnswerOptions.length)) {
      alertMessage = 'Please add the required comment.';
    }
  }

  return (
    <Box
      style={{
        margin: 'auto',
        overflowY: 'auto',
        width: isMobileView() ? 'auto' : '70vw',
        minWidth: isMobileView() ? '0' : '600px',
      }}
    >
      <Box
        style={{
          margin: 'auto',
          overflowY: 'auto',
          width: isMobileView() ? '80%' : '40vw',
        }}
      >
        <TextHeader1
          style={{
            fontSize: isMobileView() ? '1.5rem' : '2.0rem',
          }}
          mb={isMobileView() ? 1 : 4}
          align="center"
        >
          {`${serialNumber}. ${description}${isRequired ? '*' : ''}`}
        </TextHeader1>

        <Collapse in={Boolean(alertMessage)}>
          {isMobileView() ? (
            <TextBodyMedium color="#d32f2f">{alertMessage}</TextBodyMedium>
          ) : (
            <AlertBox message={alertMessage} severity="error" />
          )}
        </Collapse>
      </Box>

      <InteractiveInput
        data={answerOptions}
        onSelect={(selectedId) =>
          dispatch(
            updateAnswerAction({
              surveyId,
              questionId: id,
              answerId: selectedId,
              feedbackText,
              isPreview,
            })
          )
        }
        type={answerType}
        selectedId={selectedAnswerOptions?.[0]?.id}
      />
      {enableFeedbackText && (
        <Box
          style={{
            margin: 'auto',
            overflowY: 'auto',
            width: isMobileView() ? '80%' : '40vw',
            marginTop: isMobileView() ? '8px' : '24px',
          }}
        >
          <AutoResizeInput
            isDashed
            defaultValue={feedbackText}
            placeholder={`Add a comment to this question${isTextRequired ? '*' : ''}`}
            onBlur={(e) => {
              dispatch(
                updateAnswerAction({
                  surveyId,
                  questionId: id,
                  answerId: selectedAnswerOptions?.[0]?.id ?? null,
                  feedbackText: e.target.value || null,
                  isPreview,
                })
              );
            }}
            rows={3}
          />
        </Box>
      )}
    </Box>
  );
};

export { EngagementQuestionCard };
